import _ from 'lodash';
import React from 'react';


function colorFromSales(n) {
  const colormix = (n, min, max, color1, color2) => `rgba(${color1[0] + (color2[0] - color1[0]) * Math.min(1, Math.max(0, (n - min) / (max - min)))},${color1[1] + (color2[1] - color1[1]) * Math.min(1, Math.max(0, (n - min) / (max - min)))},${color1[2] + (color2[2] - color1[2]) * Math.min(1, Math.max(0, (n - min) / (max - min)))}, 0.8)`;
  const gray = [150, 150, 150];
  const red = [200, 130, 130];
  const yellow = [230, 200, 0];
  const green = [50, 150, 70];
  const supergreen = [0, 255, 0];
  const purple = [0, 220, 180];
  if (n < 100) {
    return colormix(n, 0, 100, gray, red);
  } else if (n < 1000) {
    return colormix(n, 100, 1000, red, yellow);
  } else if (n < 10000) {
    return colormix(n, 1000, 10000, yellow, green);
  } else if (n < 100000) {
    return colormix(n, 10000, 100000, green, supergreen);
  } else {
    return colormix(n, 100000, 500000, supergreen, purple);
  }
}

export function SalesByYearMiniature({ salesByYear, soldIntervals }) {
  if (!salesByYear && !soldIntervals?.length) return null;

  salesByYear = salesByYear || {};
  soldIntervals = soldIntervals || [];

  // Years range from 2000 to 2026 (27 years)
  const startYear = 2000;
  const endYear = new Date().getFullYear();
  const yearsCount = endYear - startYear + 1;
  const width = 250;
  const height = 50;
  const barGap = 1;
  const barWidth = (width - (yearsCount - 1) * barGap) / yearsCount;

  // Prepare sales data for each year
  const salesNumbers = [];
  for (let year = startYear; year <= endYear; year++) {
    let salesObj = salesByYear[year];
    let val = 0;
    if (salesObj && salesObj.sales && salesObj.sales >= 0) {
      val = salesObj.sales;
    } else {
      val = 0;
    }
    salesNumbers.push(val);
  }

  // Determine max for bar scaling
  const maxVal = Math.max(... (_.values(salesByYear).map(val => val?.sales || 0)));

  let color = colorFromSales(_.sum(salesNumbers));

  // Make a simple bar chart in a canvas
  return (
    <canvas
      width={width}
      height={height}
      style={{ width: width, height: height, display: 'block', background: '#fff5', border: '1px solid #eee', borderRadius: '3px', marginTop: '-5px', marginBottom: '-5px' }}
      ref={ref => {
        if (ref) {
          const ctx = ref.getContext('2d');
          ctx.clearRect(0, 0, width, height);
          const scale = window.devicePixelRatio || 1;
          ref.width = width * scale;
          ref.height = height * scale;
          ctx.scale(scale, scale);

          // Create a linear gradient used for solved == true
          const soldTrueGradient = ctx.createLinearGradient(0, 0, 0, height);
          soldTrueGradient.addColorStop(0.4, "#ffffff00");
          // soldTrueGradient.addColorStop(0.25, "green");
          // soldTrueGradient.addColorStop(0.5, "white");
          soldTrueGradient.addColorStop(0.6, "#9FF");
          soldTrueGradient.addColorStop(1, "#05F");

          for (let i = 0; i <= (endYear - startYear); i++) {
            const year = i + startYear;

            const val = salesByYear[year]?.sales;            

            const x = i * (barWidth + barGap);

            if (year % 10 === 0) {
              ctx.strokeStyle = '#0006';
              ctx.strokeRect(x, 0, 0.5, height);
              ctx.fillStyle = '#0003';
              ctx.font = 'bold 12px sans-serif';
              ctx.textAlign = 'center';
              ctx.fillText(`${startYear + i}`, x + 17, 12);
            }

            if(!soldIntervals?.length || soldIntervals.some(period => period.from <= year && (period.to >= year || !period.to))) {
              ctx.fillStyle = '#FFFFFF33';
            } else {
              ctx.fillStyle = '#00000033';            
            }
            ctx.fillRect(x, 0, barWidth+barGap, height); // at least 2px if present

            if (val !== true && val !== false) {
              const h = Math.round(val / maxVal * (height - 15)) + 1;
              const y = height - h;
              color = colorFromSales(val);

              ctx.fillStyle = val > 0 ? color : '#00000033'
              ctx.fillRect(x, y, barWidth, h || 2); // at least 2px if present

              if (val === maxVal) {
                ctx.fillStyle = '#fff';
                ctx.font = 'bold 9px sans-serif';
                ctx.textAlign = 'center';
                ctx.fillText(val.toLocaleString(), x + barWidth / 2 - 1, y - 3 - 1);
                ctx.fillStyle = '#0009';
                ctx.fillText(val.toLocaleString(), x + barWidth / 2, y - 3);
              }
            } else if (val === true) {
              ctx.fillStyle = soldTrueGradient;
              ctx.fillRect(x, 0, barWidth, height); // at least 2px if present
            } else if(val === false) {
              // ctx.fillStyle =  '#00000033';            
              // ctx.fillRect(x, 0, barWidth, height);
              ctx.fillStyle =  '#00000099';            
              ctx.font = 'bold 6px sans-serif';
              ctx.fillText('❌', x + barWidth / 2, height - 2);
            }
          }
        }
      }}
      title={salesNumbers.map((val, i) => (val > 0 ? `${startYear + i}: ${val}` : '')).filter(Boolean).join('\n')} />
  );
}
